export default "<div class=\"centerDiv\">\r\n\t{{warningText}}\r\n</div>\r\n"